import { Component, ChangeDetectionStrategy } from '@angular/core';
import { untranslatedString } from 'models/translated-string';
import { CsPage, NavController } from 'providers/nav-controller';
import { UserDb } from 'services/user-db.service';
import { getMyApp } from 'app/app-interface';
import { LoadingController } from 'providers/loading-controller';
import { stopImpersonatingAsync } from 'services/impersonation-stop';
import { ModalPageMarker } from 'providers/modal-page-marker';
import { AdminImpersonatedUserPageParams } from './admin-impersonated-user-interface';

@Component({
    selector: 'page-admin-impersonated-user',
    templateUrl: 'admin-impersonated-user.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ModalPageMarker]
})
export class AdminImpersonatedUserPage extends CsPage<AdminImpersonatedUserPageParams> {
  // read through UserDb, which reports a damaged or unreadable value once per page load (#5191)
  get impersonationUserAuth() {
    return this.userDb.getImpersonationUserAuth();
  }

  constructor(
    public navCtrl: NavController,
    private userDb: UserDb,
    private loadingCtrl: LoadingController,
  ) {
    super();
  }

  async onStopImpersonatingButtonClicked() {
    let loader = this.loadingCtrl.create({
      content: untranslatedString('Switching back to original profile data. Please wait...'),
    });
    // #6448: reload straight away and delete the copy on the next start. Opening the home page or
    // deleting the copy in this session copied a customer's entries into the officer's account.
    try {
      await stopImpersonatingAsync({
        clearImpersonationFlag: () => this.userDb.setImpersonationUserAuth(null),
        markTemporaryCopyForDeletion: () => this.userDb.markImpersonationCopyForDeletion(),
        // resetToRoot: true forces cold start and clears warm_resume_url;
        // otherwise the next boot warm-resumes to /admin-impersonated-user
        // with the flag cleared, which renders blank (#3352).
        reloadAppAsync: () => getMyApp().reloadAppAsync({ resetToRoot: true }),
      });
    } finally {
      await loader.dismiss();
    }
  }
}
